import {TransactionId} from '@raison/types';
import {InfoPage, RsnButton, RsnTextButton} from '@raison/ui-kit';
import BigNumber from 'bignumber.js';
import React from 'react';
import {useNavigate} from 'react-router';
import {Currency, useCurrencyFormat} from '~/entities/currencies';

export type SendConfirmationFinishState = {
    amount: BigNumber;
    orderId: TransactionId;
};

const directions = {
    in: '+',
    out: '-',
};

export function OrderPlacedInfoPage({
    currency,
    amount,
    goToDetails,
    direction,
    details,
}: {
    currency: Currency;
    amount: string | BigNumber;
    goToDetails: () => void;
    direction: keyof typeof directions;
    details: string;
}) {
    const {format: formatAsSubject} = useCurrencyFormat(currency);
    const amountText = formatAsSubject(amount);
    const t = {
        Heading: directions[direction] + amountText,
        Details: details,
        GoHome: 'Back to home',
        ViewDetails: 'View operation details',
    };

    const navigate = useNavigate();
    const goHome = () => {
        navigate('/');
    };

    return (
        <InfoPage.Layout symbol='success'>
            {{
                center: (
                    <InfoPage.Center heading={t.Heading} details={t.Details}>
                        <RsnTextButton.Block decoration='arrow-right' size={'l'} onClick={goToDetails}>
                            {t.ViewDetails}
                        </RsnTextButton.Block>
                    </InfoPage.Center>
                ),
                footer: <RsnButton.Primary onClick={goHome}>{t.GoHome}</RsnButton.Primary>,
            }}
        </InfoPage.Layout>
    );
}
